(function (Drupal) {
  'use strict';

  class OuigoHeader {
    constructor(element) {
      this.header = element;
      this.submenus = [];
      this.init();
    }

    init() {
      const menuItems = this.header.querySelectorAll('.ouigo-header__item--has-submenu');
      menuItems.forEach((item, index) => {
        const link = item.querySelector('.ouigo-header__link');
        const toggle = item.querySelector('.ouigo-header__toggle');
        const submenu = item.querySelector('.ouigo-header__submenu');

        const triggers = Array.from(new Set([link, toggle].filter(Boolean)));

        if (triggers.length > 0 && submenu) {
          this.submenus.push({ item, triggers, submenu });
          this.setupDropdown(triggers, submenu, item);
          this.initExplorerHover(submenu);
        }
      });

      const langSelector = this.header.querySelector('.ouigo-header__lang');
      if (langSelector) {
        const trigger = langSelector.querySelector('.ouigo-header__lang-trigger');
        const submenu = langSelector.querySelector('.ouigo-header__lang-menu');
        if (trigger && submenu) {
          this.setupDropdown([trigger], submenu, langSelector);
        }

        const langToggles = langSelector.querySelectorAll('.ouigo-header__lang-toggle');
        langToggles.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            const item = btn.closest('.ouigo-header__lang-item');
            const panel = item ? item.querySelector('.ouigo-header__lang-sub-panel') : null;
            const plusMinus = btn.querySelector('.ouigo-header__lang-plus-minus');
            
            if (panel) {
              const isExpanded = btn.getAttribute('aria-expanded') === 'true';
              
              langToggles.forEach((otherBtn) => {
                if (otherBtn !== btn) {
                  otherBtn.setAttribute('aria-expanded', 'false');
                  const otherItem = otherBtn.closest('.ouigo-header__lang-item');
                  const otherPanel = otherItem ? otherItem.querySelector('.ouigo-header__lang-sub-panel') : null;
                  const otherPlusMinus = otherBtn.querySelector('.ouigo-header__lang-plus-minus');
                  if (otherPanel) {
                    otherPanel.style.display = 'none';
                  }
                  if (otherPlusMinus) {
                    otherPlusMinus.textContent = '+';
                  }
                }
              });

              if (isExpanded) {
                btn.setAttribute('aria-expanded', 'false');
                panel.style.display = 'none';
                if (plusMinus) {
                  plusMinus.textContent = '+';
                }
              } else {
                btn.setAttribute('aria-expanded', 'true');
                panel.style.display = 'flex';
                if (plusMinus) {
                  plusMinus.textContent = '−';
                }
              }
            }
          });
        });
      }

      const mobileToggle = this.header.querySelector('.ouigo-header__mobile-toggle');
      const mobileClose = this.header.querySelector('.ouigo-header__mobile-close');
      const mobileDrawer = this.header.querySelector('.ouigo-header__mobile-drawer');
      
      if (mobileToggle && mobileClose && mobileDrawer) {
        mobileToggle.addEventListener('click', (event) => {
          event.preventDefault();
          this.openMobileDrawer(mobileToggle, mobileDrawer);
        });

        mobileClose.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeMobileDrawer(mobileToggle, mobileDrawer);
        });
      }

      const mobileLangTrigger = this.header.querySelector('.ouigo-header__mobile-lang-trigger');
      const mobileLangOverlay = this.header.querySelector('.ouigo-header__mobile-lang-modal-overlay');
      const mobileLangClose = this.header.querySelector('.ouigo-header__mobile-lang-modal-close');
      
      if (mobileLangTrigger && mobileLangOverlay) {
        mobileLangTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeAllMobileSubmenus(mobileLangTrigger);
          mobileLangTrigger.setAttribute('aria-expanded', 'true');
          mobileLangOverlay.setAttribute('aria-hidden', 'false');
          mobileLangOverlay.classList.add('ouigo-header__mobile-lang-modal-overlay--open');
        });

        if (mobileLangClose) {
          mobileLangClose.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            mobileLangTrigger.setAttribute('aria-expanded', 'false');
            mobileLangOverlay.setAttribute('aria-hidden', 'true');
            mobileLangOverlay.classList.remove('ouigo-header__mobile-lang-modal-overlay--open');
          });
        }

        mobileLangOverlay.addEventListener('click', (event) => {
          if (event.target === mobileLangOverlay) {
            mobileLangTrigger.setAttribute('aria-expanded', 'false');
            mobileLangOverlay.setAttribute('aria-hidden', 'true');
            mobileLangOverlay.classList.remove('ouigo-header__mobile-lang-modal-overlay--open');
          }
        });

        const mobileLangToggles = mobileLangOverlay.querySelectorAll('.ouigo-header__mobile-lang-toggle');
        mobileLangToggles.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            
            const item = btn.closest('.ouigo-header__mobile-lang-item');
            const panel = item ? item.querySelector('.ouigo-header__mobile-lang-sub-panel') : null;
            const plusMinus = btn.querySelector('.ouigo-header__mobile-lang-plus-minus');
            
            if (panel) {
              const isExpanded = btn.getAttribute('aria-expanded') === 'true';
              
              mobileLangToggles.forEach((otherBtn) => {
                if (otherBtn !== btn) {
                  otherBtn.setAttribute('aria-expanded', 'false');
                  const otherItem = otherBtn.closest('.ouigo-header__mobile-lang-item');
                  const otherPanel = otherItem ? otherItem.querySelector('.ouigo-header__mobile-lang-sub-panel') : null;
                  const otherPlusMinus = otherBtn.querySelector('.ouigo-header__mobile-lang-plus-minus');
                  if (otherPanel) {
                    otherPanel.style.display = 'none';
                  }
                  if (otherPlusMinus) {
                    otherPlusMinus.textContent = '+';
                  }
                }
              });

              if (isExpanded) {
                btn.setAttribute('aria-expanded', 'false');
                panel.style.display = 'none';
                if (plusMinus) {
                  plusMinus.textContent = '+';
                }
              } else {
                btn.setAttribute('aria-expanded', 'true');
                panel.style.display = 'flex';
                if (plusMinus) {
                  plusMinus.textContent = '−';
                }
              }
            }
          });
        });
      }

      const mobileSubmenuLinks = this.header.querySelectorAll('.ouigo-header__mobile-link--has-submenu');
      mobileSubmenuLinks.forEach((link) => {
        const item = link.closest('.ouigo-header__mobile-item');
        const submenu = item ? item.querySelector('.ouigo-header__mobile-submenu') : null;
        
        if (submenu) {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const isExpanded = link.getAttribute('aria-expanded') === 'true';
            
            if (isExpanded) {
              link.setAttribute('aria-expanded', 'false');
              submenu.setAttribute('aria-hidden', 'true');
              submenu.classList.remove('ouigo-header__mobile-submenu--open');
            } else {
              this.closeAllMobileSubmenus(link);
              link.setAttribute('aria-expanded', 'true');
              submenu.setAttribute('aria-hidden', 'false');
              submenu.classList.add('ouigo-header__mobile-submenu--open');
            }
          });
        }
      });

      if (mobileDrawer && mobileToggle) {
        const mobileLinks = mobileDrawer.querySelectorAll('a');
        mobileLinks.forEach((link) => {
          if (!link.classList.contains('ouigo-header__mobile-link--has-submenu')) {
            link.addEventListener('click', () => {
              this.closeAllMobileSubmenus();
              this.closeMobileDrawer(mobileToggle, mobileDrawer);
            });
          }
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (mobileLangOverlay && mobileLangOverlay.classList.contains('ouigo-header__mobile-lang-modal-overlay--open')) {
            event.preventDefault();
            mobileLangTrigger.setAttribute('aria-expanded', 'false');
            mobileLangOverlay.setAttribute('aria-hidden', 'true');
            mobileLangOverlay.classList.remove('ouigo-header__mobile-lang-modal-overlay--open');
            mobileLangTrigger.focus();
          } else if (mobileDrawer && mobileDrawer.classList.contains('ouigo-header__mobile-drawer--open')) {
            event.preventDefault();
            this.closeAllMobileSubmenus();
            this.closeMobileDrawer(mobileToggle, mobileDrawer);
          }
        }
      });

      const mobilePromo = this.header.querySelector('.ouigo-header__mobile-promo');
      if (mobilePromo) {
        this.initMobilePromo(mobilePromo);
      }

      document.addEventListener('click', (event) => this.handleClickOutside(event));

      let resizeTimeout;
      window.addEventListener('resize', () => {
        if (resizeTimeout) {
          window.cancelAnimationFrame(resizeTimeout);
        }
        resizeTimeout = window.requestAnimationFrame(() => {
          this.submenus.forEach(({ submenu }) => {
            if (submenu && submenu.getAttribute('aria-hidden') === 'false') {
              this.adjustSubmenuPosition(submenu);
            }
          });
          const langSelector = this.header.querySelector('.ouigo-header__lang');
          if (langSelector) {
            const langMenu = langSelector.querySelector('.ouigo-header__lang-menu');
            if (langMenu && langMenu.getAttribute('aria-hidden') === 'false') {
              this.adjustSubmenuPosition(langMenu);
            }
          }
        });
      });
    }

    openMobileDrawer(toggle, drawer) {
      toggle.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('ouigo-header__mobile-drawer--open');
      document.body.style.overflow = 'hidden'; 
      document.documentElement.style.overflow = 'hidden';
      
      const closeBtn = drawer.querySelector('.ouigo-header__mobile-close');
      if (closeBtn) {
        closeBtn.focus();
      }
    }

    closeMobileDrawer(toggle, drawer) {
      toggle.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('ouigo-header__mobile-drawer--open');
      document.body.style.overflow = ''; 
      document.documentElement.style.overflow = '';
      
      toggle.focus();
    }

    closeAllMobileSubmenus(exceptLink = null) {
      const submenuLinks = this.header.querySelectorAll('.ouigo-header__mobile-link--has-submenu');
      submenuLinks.forEach((link) => {
        if (link !== exceptLink) {
          link.setAttribute('aria-expanded', 'false');
          const item = link.closest('.ouigo-header__mobile-item');
          const submenu = item ? item.querySelector('.ouigo-header__mobile-submenu') : null;
          if (submenu) {
            submenu.setAttribute('aria-hidden', 'true');
            submenu.classList.remove('ouigo-header__mobile-submenu--open');
          }
        }
      });

      const langTrigger = this.header.querySelector('.ouigo-header__mobile-lang-trigger');
      const langOverlay = this.header.querySelector('.ouigo-header__mobile-lang-modal-overlay');
      if (langTrigger && langOverlay && langTrigger !== exceptLink) {
        langTrigger.setAttribute('aria-expanded', 'false');
        langOverlay.setAttribute('aria-hidden', 'true');
        langOverlay.classList.remove('ouigo-header__mobile-lang-modal-overlay--open');
      }
    }

    setupDropdown(triggers, submenu, wrapper) {
      const triggerArray = Array.isArray(triggers) ? triggers : [triggers];

      triggerArray.forEach((trigger) => {
        trigger.setAttribute('aria-haspopup', 'true');
        if (!trigger.hasAttribute('aria-expanded')) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });

      triggerArray.forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          
          const primaryTrigger = triggerArray[0];
          const isExpanded = primaryTrigger.getAttribute('aria-expanded') === 'true';
          
          this.closeAllDropdowns(primaryTrigger);

          if (isExpanded) {
            this.closeDropdown(triggerArray, submenu);
          } else {
            this.openDropdown(triggerArray, submenu);
          }
        });
      });

      wrapper.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          const primaryTrigger = triggerArray[0];
          const isExpanded = primaryTrigger.getAttribute('aria-expanded') === 'true';
          if (isExpanded) {
            event.preventDefault();
            this.closeDropdown(triggerArray, submenu);
            primaryTrigger.focus();
          }
        }
      });

      wrapper.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!wrapper.contains(document.activeElement)) {
            this.closeDropdown(triggerArray, submenu);
          }
        }, 50);
      });
    }

    initExplorerHover(submenu) {
      const cards = submenu.querySelectorAll('.ouigo-header__explorer-card[data-explorer-id]');
      const triggers = submenu.querySelectorAll('[data-explorer-target]');

      if (cards.length === 0 || triggers.length === 0) return;

      // Afficher uniquement la première carte au chargement
      cards.forEach((card, i) => { card.hidden = i !== 0; });
      triggers[0].classList.add('ouigo-header__submenu-link--explorer-active');

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => {
          const targetId = trigger.dataset.explorerTarget;
          cards.forEach((card) => {
            card.hidden = card.dataset.explorerId !== targetId;
          });
          triggers.forEach((t) => {
            t.classList.toggle('ouigo-header__submenu-link--explorer-active', t === trigger);
          });
        });
      });
    }

    initMobilePromo(promoSection) {
      const promoImg = promoSection.querySelector('.ouigo-header__mobile-promo-image');
      const promoBtn = promoSection.querySelector('.ouigo-header__mobile-promo-btn');
      const mobileMenu = this.header.querySelector('.ouigo-header__mobile-menu');
      if (!mobileMenu) return;

      const triggers = mobileMenu.querySelectorAll('[data-promo-picture]');
      if (triggers.length === 0) return;

      const updatePromo = (trigger) => {
        const picture = trigger.dataset.promoPicture || '';
        const alt = trigger.dataset.promoPictureAlt || '';
        const title = trigger.dataset.promoTitle || '';
        const link = trigger.dataset.promoLink || '#';

        if (promoImg) {
          promoImg.src = picture;
          promoImg.alt = alt;
          promoImg.style.display = picture ? '' : 'none';
        }
        if (promoBtn) {
          promoBtn.textContent = title;
          promoBtn.href = link;
        }

        triggers.forEach((t) => {
          t.classList.toggle('ouigo-header__mobile-submenu-link--promo-active', t === trigger);
        });
      };

      triggers.forEach((trigger) => {
        trigger.addEventListener('mouseenter', () => updatePromo(trigger));
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          updatePromo(trigger);
        });
      });
    }

    resetExplorerToFirst(submenu) {
      const cards = submenu.querySelectorAll('.ouigo-header__explorer-card[data-explorer-id]');
      const triggers = submenu.querySelectorAll('[data-explorer-target]');
      if (cards.length === 0) return;
      cards.forEach((card, i) => { card.hidden = i !== 0; });
      triggers.forEach((t, i) => {
        t.classList.toggle('ouigo-header__submenu-link--explorer-active', i === 0);
      });
    }

    openDropdown(triggers, submenu) {
      const triggerArray = Array.isArray(triggers) ? triggers : [triggers];
      submenu.style.removeProperty('--submenu-shift-x');
      triggerArray.forEach((trigger) => trigger.setAttribute('aria-expanded', 'true'));
      submenu.setAttribute('aria-hidden', 'false');
      this.adjustSubmenuPosition(submenu);
      this.resetExplorerToFirst(submenu);

      const firstTrigger = triggerArray[0];
      if (firstTrigger) {
        const wrapper = firstTrigger.closest('.ouigo-header__nav-wrapper');
        if (wrapper) {
          wrapper.classList.add('ouigo-header__nav-wrapper--expanded');
        }
      }
    }

    closeDropdown(triggers, submenu) {
      const triggerArray = Array.isArray(triggers) ? triggers : [triggers];
      triggerArray.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      submenu.setAttribute('aria-hidden', 'true');

      setTimeout(() => {
        if (submenu.getAttribute('aria-hidden') === 'true') {
          submenu.style.removeProperty('--submenu-shift-x');
        }
      }, 250);

      const firstTrigger = triggerArray[0];
      if (firstTrigger) {
        const wrapper = firstTrigger.closest('.ouigo-header__nav-wrapper');
        if (wrapper) {
          wrapper.classList.remove('ouigo-header__nav-wrapper--expanded');
        }
      }
    }

    adjustSubmenuPosition(submenu) {
      if (!submenu) return;
      submenu.style.removeProperty('--submenu-shift-x');
      const rect = submenu.getBoundingClientRect();
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const padding = 16;
      let shift = 0;

      if (rect.right > viewportWidth - padding) {
        shift = (viewportWidth - padding) - rect.right;
      } else if (rect.left < padding) {
        shift = padding - rect.left;
      }

      if (shift !== 0) {
        submenu.style.setProperty('--submenu-shift-x', `${shift}px`);
      }
    }

    closeAllDropdowns(exceptTrigger = null) {
      this.submenus.forEach(({ triggers, submenu }) => {
        const triggerArray = Array.isArray(triggers) ? triggers : [triggers];
        if (!triggerArray.includes(exceptTrigger)) {
          this.closeDropdown(triggerArray, submenu);
        }
      });

      const langSelector = this.header.querySelector('.ouigo-header__lang');
      if (langSelector) {
        const trigger = langSelector.querySelector('.ouigo-header__lang-trigger');
        const submenu = langSelector.querySelector('.ouigo-header__lang-menu');
        if (trigger && submenu && trigger !== exceptTrigger) {
          this.closeDropdown([trigger], submenu);
        }
      }
    }

    handleClickOutside(event) {
      if (!this.header.contains(event.target)) {
        this.closeAllDropdowns();
        
        const mobileToggle = this.header.querySelector('.ouigo-header__mobile-toggle');
        const mobileDrawer = this.header.querySelector('.ouigo-header__mobile-drawer');
        if (mobileDrawer && mobileDrawer.classList.contains('ouigo-header__mobile-drawer--open')) {
          this.closeMobileDrawer(mobileToggle, mobileDrawer);
        }
      }
    }
  }

  Drupal.behaviors.ouigoHeader = {
    attach: function (context) {
      const headers = context.querySelectorAll('.ouigo-header');
      headers.forEach((header) => {
        if (!header.dataset.ouigoHeaderInitialized) {
          header.dataset.ouigoHeaderInitialized = 'true';
          new OuigoHeader(header);
        }
      });
    }
  };

})(Drupal);
